import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { RichText } from "@payloadcms/richtext-lexical/react";

function BlogArea() {
  const {
    data: blogs,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["recent-blogs"],
    queryFn: async () => {
      const { data } = await axios.get(
        `https://be-staging.obigin.com/content/related-blogs`
      );
      return data.data;
    },
  });

  if (isLoading) return <p className="text-center">Loading...</p>;
  if (isError) return <p className="text-center">Failed to load blogs.</p>;

  return (
    <section className="blog-area pt-115">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8">
            <div className="section-title title-style-three text-center mb-70">
              <h2>
             Related <span>News & Updates</span>
              </h2>
              <p>
                Dive into behind‑the‑scenes stories, prototype deep‑dives, and
                growth hacks from the Obigin team—alongside fresh updates on
                tournaments, new features, and dev journeys.
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          {blogs?.slice(0, 3).map((blog) => (
            <div key={blog.slug} className="col-lg-4 col-md-6">
              <div className="blog-post blog-style-two mb-50">
                <div className="blog-thumb mb-30">
                  <Link to={`/blogs/${blog._id}`}>
                    <img src={blog.coverImage} alt={blog.title} />
                  </Link>
                </div>
                <div className="blog-post-content">
                  <h4>
                    <Link to={`/blog/${blog.slug}`}>{blog.title}</Link>
                  </h4>
                  <div className="blog-meta">
                    <ul>
                      <li>
                        <i className="far fa-clock" />
                        {new Date(blog.createdAt).toLocaleDateString()}
                      </li>
                      <li>
                        <i className="fas fa-tag" />
                        <Link to={`/category/${blog.category}`}>
                          {blog.category}
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    <RichText data={blog.content} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BlogArea;
